import { useMutation, useQueryClient } from '@tanstack/react-query';
import { shippingService } from '../services/shipping.service';

export function useDeleteShippingRate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (refId: string) => shippingService.deleteShippingRate(refId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipping-rates'] });
    },
  });
}

export function useDeleteShippingZone() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (refId: string) => shippingService.deleteShippingZone(refId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipping-zones'] });
    },
  });
}
